<template>
  <div>
    <v-collapse-group>
      <v-collapse-wrapper :active="true">
        <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
             v-collapse-toggle>
          <div class="a-ui-tab__file-flex-block">
            <div class="a-ui-tab__file-item-left">
              <h3>
                {{$t('labels.bid')}}
              </h3>
            </div>
            <div class="a-ui-tab__file-item-right">
              <button class="gui-btn gui-btn--red"
                      @click.prevent.stop="onDownloadAllFilesClick">Скачать файлы одним архивом</button>
            </div>
          </div>
        </div>
        <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
          <div class="a-container-form">
            <div class="a-label a-label--w-280">{{$t('form.lot.requests-table.bid-status')}}:</div>
            <span class="a-input a-input--disabled" :class="{'u-red-color u-font-size-22 u-hr-underline': bid.state.SUSPENDED}" v-t="bid.state.label"></span>
            <span type="button" class="gui-btn-none-style"
                  @click="onBidSignCheckClick"
                  v-if="bid.hasSign">
              <img class="accreditation__reg-img" src="@/assets/img/static/b-icon_edit.svg" alt="">
            </span>
          </div>

          <template v-if="bid.state == enums.BidState.ACCEPTED">
            <div class="a-container-form">
              <div class="a-label a-label--w-280">Дата акцепта</div>
              <date-time :value="bid.acceptTime"></date-time>
            </div>
          </template>

          <div class="a-container-form" v-if="bid.confirmedState">
            <div class="a-label a-label--w-280">{{$t('form.lot.confirmed-request-status')}}:</div>
            <label class="a-input a-input--disabled u-red-color">{{$t(bid.confirmedState.label)}}</label>
          </div>
          <div class="a-container-form" v-if="bid.state.DECLINED">
            <div class="a-label a-label--w-280">{{$t('form.lot.reason-for-rejection')}}:</div>
            <p class="a-input a-input--disabled ">
              {{bid.reason}}
            </p>
          </div>
          <div class="a-container-form">
            <div class="a-label a-label--w-280"></div>
            <div>
              <file-link :name="file.name"
                         :size="file.size"
                         :link="externalLink(file.uid)"
                         :key="file.uid"
                         :signed="file.hasSign"
                         v-for="file in bid.filesState">
              </file-link>
            </div>
          </div>

          <template v-if="bid.documents.length">
            <div class="a-tab__title-block admin__a-tab admin__a-tab">
              <h3>Требуемые документы по предложению</h3>
            </div>
            <div class="admin__a-tab-content admin__a-tab-content--show">
              <files-for-document-in-bid :lot="lot" :bid="bid"></files-for-document-in-bid>
            </div>
            <div class="u-indent-m-b-40px"></div>
          </template>

          <div class="a-container-form" v-if="bid.permissions.CAN_EDIT_BID">
            <div class="a-label a-label--w-280">
              {{$t('form.lot.additional-information')}}:
              <v-popover class="d-inline-block" placement="right" v-if="lot.additionalInfo && bidDescription">
                <img src="@/assets/img/static/info.svg">

                <template slot="popover">
                  <span v-html="lot.additionalInfo"></span>
                </template>
              </v-popover>
            </div>

            <textarea class="a-textarea"
                      rows="10"
                      :placeholder="lot.additionalInfo"
                      v-model="bidDescription"
                      @change="onChangeDescription">
            </textarea>
          </div>

          <div class="a-container-form" v-else-if="bid.description">
            <div class="a-label a-label--w-280">{{$t('form.lot.additional-information')}}:</div>
            <p class="a-input a-input--disabled">{{bid.description}}</p>
          </div>

          <div class="a-container-form a-container-form--align-start" v-if="bid.permissions.CAN_EDIT_BID || bid.files.length > 0">
            <div class="a-label a-label--w-280">{{$t('labels.files')}}:</div>
            <div >
              <file-link :name="file.name"
                         :size="file.size"
                         :link="externalLink(file.uid)"
                         :removable="bid.permissions.CAN_EDIT_BID"
                         :key="file.uid"
                         :signed="file.hasSign"
                         @onsigncheck="onBidFileSignCheckClick(file.num)"
                         @remove="onRemoveBidFile(file.num)"
                         v-for="file in bid.files">
              </file-link>

              <file-picker @prepared="onBidFileSelected"
                           :signing="lot.permissions.SHOULD_BE_SIGNED"
                           v-if="bid.permissions.CAN_EDIT_BID">
              </file-picker>

              <p class="a-input a-input--disabled" v-else-if="bid.files.length === 0">{{$t('labels.no-files')}}</p>
            </div>
          </div>
        </div>
      </v-collapse-wrapper>

      <v-collapse-wrapper :active="true">
        <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
             v-collapse-toggle>
          <h3>{{$t('form.lot.expert-criteria')}}</h3>
        </div>
        <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
          <expert-criteria-in-request :lot="lot" :bid="bid"></expert-criteria-in-request>
        </div>
      </v-collapse-wrapper>

      <v-collapse-wrapper :active="true">
        <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
             v-collapse-toggle>
          <h3>{{$t('form.lot.price-criteria')}}</h3>
        </div>
        <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
          <price-criteria-in-request :lot="lot" :bid="bid"></price-criteria-in-request>
        </div>
      </v-collapse-wrapper>

      <v-collapse-wrapper :active="true">
        <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
             v-collapse-toggle>
          <h3>{{$t('form.lot.specification')}}</h3>
        </div>
        <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
          <specification-in-request :lot="lot" :bid="bid"></specification-in-request>
        </div>
      </v-collapse-wrapper>

      <v-collapse-wrapper :active="true">
        <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
             v-collapse-toggle>
          <h3>{{$t('form.lot.parts-and-payments')}}</h3>
        </div>
        <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
          <payments-and-parts-in-request-bid :lot="lot" :bid="bid"></payments-and-parts-in-request-bid>
        </div>
      </v-collapse-wrapper>

      <template v-if="lot.state.RETEND || lot.state.WAITING_FOR_RETEND">
        <!--<v-collapse-wrapper :active="true">-->
          <div class="a-tab__title-block admin__a-tab u-border-0 u-indent-m-b-45px">
            <div class="a-container-form " v-if="nextRetendRequestTimeLeft && retendTimeLeft">
              <div class="a-label a-col-label a-label--w-280">{{$t('form.lot.due-date-for-next-bid')}}:</div>
              <div class="a-col-block-content ">
                <timer :value="nextRetendRequestTimeLeft" @finish="checkPublicLot"></timer>
              </div>
            </div>
            <div class="a-container-form" v-if="retendTimeLeft && nextRetendRequestTimeLeft">
              <div class="a-label a-col-label a-label--w-280">{{$t('form.lot.time-left-to-retend-finish')}}:</div>
                <div class="a-col-block-content ">
                <timer :value="retendTimeLeft" @finish="checkPublicLot"></timer>
              </div>
            </div>

            <div class="a-container-form " v-if="lot.antisniper">
              <label class="a-label u-width-615px u-red-color">
                Включено автоматическое продление торга. На {{lot.antisniper}} минут продлевается прием предложений в случае активности участников регистрации изменений в предложении
              </label>
            </div>
          </div>
        <!--</v-collapse-wrapper>-->
      </template>

      <!--<v-collapse-wrapper :active="true">-->
        <div class="a-tab__title-block admin__a-tab u-border-0"
             v-if="bid.presentPrice !== undefined || bid.estimate !== undefined || bid.rating !== undefined">
          <h3>{{$t('form.lot.own-bid')}}</h3>
        </div>
        <!--<div v-collapse-content>-->
        <div>
          <div class="a-container-form" v-if="bid.presentPrice !== undefined">
            <div class="a-label a-label--w-280">{{$t('form.lot.requests-table.present-price')}}:</div>
            <p class="a-input a-input--disabled">{{bid.presentPrice|price}} BYN</p>
          </div>
          <div class="a-container-form" v-if="bid.estimate !== undefined">
            <div class="a-label a-label--w-280">{{$t('form.lot.requests-table.final-estimation')}}:</div>
            <p class="a-input a-input--disabled">{{bid.estimate|finalEstimation}}</p>
          </div>
          <div class="a-container-form" v-if="bid.rating !== undefined">
            <div class="a-label a-label--w-280">{{$t('form.lot.requests-table.rating')}}:</div>
            <p class="a-input a-input--disabled">{{bid.rating}}</p>
          </div>
          <div class="a-container-form" v-if="bid.rating === 1 && lot.nbOfLeaders > 1">
            <div class="a-label a-label--w-280">Лидирующих предложений:</div>
            <p class="a-input a-input--disabled">{{lot.nbOfLeaders}}</p>
          </div>
        </div>
      <!--</v-collapse-wrapper>-->

      <!--<v-collapse-wrapper :active="true">-->
        <div class="a-tab__title-block admin__a-tab u-border-0"
             v-if="bid.minimalPresentPrice !== undefined || bid.otherEstimate !== undefined">
          <h3>{{$t('form.lot.best-bid')}}</h3>
        </div>
        <!--<div v-collapse-content>-->
        <div>
          <div class="a-container-form" v-if="bid.minimalPresentPrice !== undefined">
            <div class="a-label a-label--w-280">{{$t('form.lot.current-computed-present-price')}}:</div>
            <p class="a-input a-input--disabled">{{bid.minimalPresentPrice|price}} BYN</p>
          </div>
          <div class="a-container-form" v-if="bid.otherEstimate !== undefined">
            <div class="a-label a-label--w-280">{{$t('form.lot.requests-table.final-estimation')}}:</div>
            <p class="a-input a-input--disabled">{{bid.otherEstimate|finalEstimation}}</p>
          </div>
        </div>
      <!--</v-collapse-wrapper>-->

      <div class="admin-buy__block-gui-btn" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_EDIT_BID_FOR_RETEND && lot.request.permissions.CAN_EDIT_BID_FOR_RETEND">
        <button class="gui-btn gui-btn--red" v-if="bid.isEditingForRetend" @click.prevent="onSendBidForRetendClick">
          {{$t('buttons.send-bid')}}
        </button>
        <button class="gui-btn gui-btn--red" v-if="bid.isEditingForRetend">
          {{$t('buttons.cancel-bid')}}
        </button>
        <button class="gui-btn gui-btn--red" v-else @click.prevent="onEditBidForRetendClick">
          {{$t('buttons.modify-bid')}}
        </button>
      </div>

      <template v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_CLARIFICATION || lot.permissions.CAN_VIEW_PUBlIC_LOT_CLARIFICATION">
        <v-collapse-wrapper :active="true" >
          <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
               v-collapse-toggle>
            <h3>{{$t('form.lot.bid-clarification')}}</h3>
          </div>
          <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
            <bid-clarification :lot="lot" :bid="bid"></bid-clarification>
          </div>
        </v-collapse-wrapper>
      </template>

      <approved-changes-history-in-request :lot="lot" :request="lot.request" :bid-num="bid.num"></approved-changes-history-in-request>
      <changes-history-table :request="lot.request" :bid="bid"></changes-history-table>

      <signing-dialog ref="signBid"
                      @signed="signBid">
      </signing-dialog>

      <signature-details-dialog ref="signCheck"></signature-details-dialog>
    </v-collapse-group>
  </div>
</template>

<script>
  import BidClarification from './BidClarification'
  import ExpertCriteriaInRequest from './ExpertCriteriaInRequestBids'
  import PriceCriteriaInRequest from './PriceCriteriaInRequestBids'
  import SpecificationInRequest from './SpecificationInRequestBids'
  import PaymentsAndPartsInRequestBid from './PaymentsAndPartsInRequestBid'
  import FilesForDocumentInBid from "./FilesForDocumentInBid";
  import Modal from '@/widgets/modal'
  import Dropdown from '@/widgets/dropdown'
  import SigningDialog from '@/components/common/dialogs/SigningDialog'
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'
  import TimersMixins from '../mixins/timers'
  import CommonMixins from '../mixins/common'
  import Errors from '@/api/types/errors'
  import ApprovedChangesHistoryInRequest from "./ApprovedChangesHistoryInRequest";
  import ChangesHistoryTable from "../changes-history/ChangesHistoryTable";

  export default {
    props: {
      bid: Object,
      lot: Object
    },

    mixins: [
      CommonMixins,
      TimersMixins
    ],

    components: {
      ChangesHistoryTable,
      BidClarification,
      ExpertCriteriaInRequest,
      PriceCriteriaInRequest,
      SpecificationInRequest,
      PaymentsAndPartsInRequestBid,
      Modal,
      Dropdown,
      SigningDialog,
      SignatureDetailsDialog,
      FilesForDocumentInBid,
      ApprovedChangesHistoryInRequest
    },

    data: () => ({
      proxy: {
        bidDescription: undefined
      }
    }),

    computed: {
      bidDescription: {
        get() {
          return this.proxy.bidDescription === undefined ? this.bid.description : this.proxy.bidDescription;
        },

        set(value) {
          this.proxy.bidDescription = value;
        }
      }
    },

    watch: {
      nextRetendRequestTimeLeft(value) {
        if (!value) {
          this.checkPublicLot();
        }
      },

      retendTimeLeft(value) {
        if (!value) {
          this.checkPublicLot();
        }
      }
    },

    methods: {
      async onChangeDescription(event) {
        this.bid.description = event.target.value
        await this.saveForm();
      }
    }
  }
</script>

<style lang="scss">
  .tooltip {
    display: block !important;
    z-index: 10000;

    .tooltip-inner {
      background: black;
      color: white;
      padding: 5px 10px 4px;
    }

    .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
      border-color: black;
      z-index: 1;

      &:before {
        content: "";
        position: absolute;
        width: 20px;
        height: 20px;
        transform: rotate(45deg);
        background: #fff;
      }
    }

    &[x-placement^="top"] {
      margin-bottom: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="bottom"] {
      margin-top: 5px;

      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0
      }
    }

    &[x-placement^="right"] {
      margin-left: 5px;

      .tooltip-arrow {
        overflow: hidden;
        width: 20px;
        height: 20px;
        left: -37px;

        &:before {
          left: 22px;
          top: calc(50% - 10px);
          box-shadow: -4px 4px 10px -4px rgba(0, 0, 0, 0.5);
        }
      }
    }

    &[x-placement^="left"] {
      margin-right: 5px;

      .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &.popover {
      $color: #ffffff;
      border: none;

      .popover-inner {
        background: $color;
        color: black;
        padding: 18px;
        box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);
        max-width: 500px;
        max-height: 70vh;
        overflow: auto;
      }

      .popover-arrow {
        z-index: 1;
        width: 32px;
        height: 32px;
        border: none;
      }
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    &.open {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }
  }
</style>
